export function buildCustomAvatarUrl({
  basePath = "",
  userId,
  avatarUpdatedAtMs,
} = {}) {
  if (!userId || !Number.isFinite(avatarUpdatedAtMs)) {
    return null;
  }

  const normalizedBasePath =
    basePath && basePath.endsWith("/") ? basePath.slice(0, -1) : basePath;

  return `${normalizedBasePath}/api/v1/media/avatar/${userId}?v=${avatarUpdatedAtMs}`;
}

export function pickAvatarUpdatedAtMs(...candidates) {
  for (const candidate of candidates) {
    if (
      candidate &&
      typeof candidate === "object" &&
      !Array.isArray(candidate)
    ) {
      if (Number.isFinite(candidate.avatarUpdatedAtMs)) {
        return candidate.avatarUpdatedAtMs;
      }

      if (Number.isFinite(candidate.avatar?.updatedAtMs)) {
        return candidate.avatar.updatedAtMs;
      }
    }

    if (Number.isFinite(candidate)) {
      return candidate;
    }
  }

  return null;
}

function hasCustomAvatarPicture(picture) {
  return (
    typeof picture === "string" && picture.includes("/api/v1/media/avatar/")
  );
}

export function resolveAvatarSrc({
  basePath = "",
  picture = null,
  userId,
  avatarUpdatedAtMs,
  hasCustomAvatar = false,
} = {}) {
  if (!picture && !hasCustomAvatar) {
    return null;
  }

  if (!hasCustomAvatar && !hasCustomAvatarPicture(picture)) {
    return picture || null;
  }

  return (
    buildCustomAvatarUrl({
      basePath,
      userId,
      avatarUpdatedAtMs,
    }) ||
    picture ||
    null
  );
}

export function resolveUserAvatarSrc({
  basePath = "",
  user = null,
  avatarCacheBust = null,
} = {}) {
  return resolveAvatarSrc({
    basePath,
    picture: user?.picture,
    userId: user?.userId || user?._id,
    avatarUpdatedAtMs: pickAvatarUpdatedAtMs(user, avatarCacheBust),
    hasCustomAvatar: !!user?.avatar,
  });
}

export function shouldResetAvatarPreview({
  hasAvatarPreviewUrl = false,
  basePath = "",
  previousUser = null,
  nextUser = null,
  previousAvatarCacheBust = null,
  nextAvatarCacheBust = null,
} = {}) {
  if (!hasAvatarPreviewUrl) {
    return false;
  }

  return (
    resolveUserAvatarSrc({
      basePath,
      user: previousUser,
      avatarCacheBust: previousAvatarCacheBust,
    }) !==
    resolveUserAvatarSrc({
      basePath,
      user: nextUser,
      avatarCacheBust: nextAvatarCacheBust,
    })
  );
}
